import { render, staticRenderFns } from "./AClientGeneral.vue?vue&type=template&id=43142dd8&"
import script from "./AClientGeneral.vue?vue&type=script&lang=js&"
export * from "./AClientGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports